<ng-container [formGroup]="form">

  <div class="row">
    <div class="col-12">
      <div class="card cl-tight">
        <div class="card-header">Watermark</div>
        <div class="card-body">
          <p>Every delivery of this type carries a Castlabs Single Frame Watermark. Codec, container and
            resolution are taken from the source and passed through unchanged; only the video essence is
            re-encoded to carry the mark.</p>

          <div class="row mb-3">
            <div class="col">
              <label class="form-label" for="sd_wm_id">ID<span class="required">*</span></label>
              <input class="form-control" [class.invalid]="form.get('sd_wm_id').errors" formControlName="sd_wm_id"
                     id="sd_wm_id" type="number">
              @if (form.get('sd_wm_id').errors?.required) {
                <p class="invalid-feedback">This field is required.</p>
              }
              @if (form.get('sd_wm_id').errors?.max) {
                <p class="invalid-feedback">The maximum value is {{ form.get('sd_wm_id').errors.max.max }}.</p>
              }
              @if (form.get('sd_wm_id').errors?.min) {
                <p class="invalid-feedback">Negative values are not permitted.</p>
              }
              @if (!form.get('sd_wm_id').errors) {
                <p class="valid-feedback">Identifies the recipient this copy is traced back to.</p>
              }
            </div>
            <div class="col">
              <label class="form-label" for="sd_strength">Strength<span class="required">*</span></label>
              <input class="form-control" [class.invalid]="form.get('sd_strength').errors" formControlName="sd_strength"
                     id="sd_strength" max="20" min="1" step="1" type="number"/>
              @if (form.get('sd_strength').errors?.required) {
                <p class="invalid-feedback">This field is required.</p>
              }
              @if (form.get('sd_strength').errors?.max) {
                <p class="invalid-feedback d-block">The maximum value is {{ form.get('sd_strength').errors.max.max }}.</p>
              }
              @if (form.get('sd_strength').errors?.min) {
                <p class="invalid-feedback d-block">The minimum value is {{ form.get('sd_strength').errors.min.min }}.</p>
              }
              @if (!form.get('sd_strength').errors) {
                <p class="valid-feedback">The default value is 4 (standard robustness).</p>
              }
            </div>
          </div>

          <div class="row mb-3">
            <div class="col">
              <label class="form-label" for="sd_bit_profile">Bit profile<span class="required">*</span></label>
              <select class="form-select" formControlName="sd_bit_profile" id="sd_bit_profile">
                @for (p of sd_bit_profiles; track p) {
                  <option [ngValue]="p.id">{{ p.name }}</option>
                }
              </select>
              <p class="valid-feedback">Sets how many distinct watermarks exist, and the highest usable ID.</p>
            </div>
            <div class="col">
              <label class="form-label" for="sd_pm_mode">Perceptual masking<span class="required">*</span></label>
              <select class="form-select" formControlName="sd_pm_mode" id="sd_pm_mode">
                @for (m of sd_pm_modes; track m) {
                  <option [ngValue]="m.id">{{ m.name }}</option>
                }
              </select>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col">
              <label class="form-label" for="sd_superpixel_density">Superpixel density</label>
              <select class="form-select" formControlName="sd_superpixel_density" id="sd_superpixel_density">
                @for (d of densities; track d) {
                  <option [ngValue]="d.id">{{ d.name }}</option>
                }
              </select>
            </div>
            <div class="col">
              <label class="form-label" for="sd_pixel_density">Pixel density</label>
              <select class="form-select" formControlName="sd_pixel_density" id="sd_pixel_density">
                @for (d of densities; track d) {
                  <option [ngValue]="d.id">{{ d.name }}</option>
                }
              </select>
            </div>
            <div class="col">
              <label class="form-label" for="sd_seed">Seed<span class="required">*</span></label>
              <input class="form-control" [class.invalid]="form.get('sd_seed').errors" formControlName="sd_seed"
                     id="sd_seed" max="31" min="-1" step="1" type="number"/>
              @if (form.get('sd_seed').errors) {
                <p class="invalid-feedback">Use -1 for automatic, or a value from 0 to 31.</p>
              } @else {
                <p class="valid-feedback">-1 picks a seed per job.</p>
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</ng-container>
